import { NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalComponent } from "../../../_shared/components/layout/modal/modal.component";
import { BaseModal } from "../../../_shared/components/layout/pages/base-modal";
import { AddressFormModel } from "../../form-models/address-form-model";
import { formatAddressLabel } from "../../utils/address-utils";
import {
  AddressBaseEditComponent,
  AddressPart,
} from "../address-base-edit/address-base-edit.component";

@Component({
  selector: "app-add-address-modal",
  standalone: true,
  imports: [NgIf, AddressBaseEditComponent, ModalComponent],
  templateUrl: "./add-address-modal.component.html",
  styleUrls: ["./add-address-modal.component.scss"],
})
export class AddAddressModalComponent extends BaseModal implements OnInit {
  addAddressForm: AddressFormModel = new AddressFormModel();
  labelName: string = "Adres";
  fields: AddressPart[] | null = null;
  showNameOnEdit: boolean = false;

  constructor(public override activeModal: NgbActiveModal) {
    super(activeModal);
    this.isLoading = false;
  }

  ngOnInit(): void {}

  onUpdated(id: number) {
    this.activeModal.close(id);
  }

  onAdded(id: number) {
    this.activeModal.close(id);
  }

  formatAddressLabel() {
    return formatAddressLabel(this.addAddressForm.model);
  }
}
